define('ordersBoardView',[
  'app',
  'module',
  'jquery',
  'backbone',
  'marionette',
  'underscore',
  'ordersBoardHeaderView',
  'ordersBoardFiltersView',
  'ordersBoardKanbanView',
  'ordersBoardFiltersLanguageView',
  'template!ordersBoardView'
], function (
  App,
  Module,
  $,
  Backbone,
  Marionette,
  _,
  HeaderView,
  FiltersView,
  KanbanView,
  LanguageFilterView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-board-view',

    regions: {
      filtersRegion: '.filters-region',
      headerRegion: '.header-region',
      kanbanRegion: '.kanban-region'
    },

    onShow: function () {
      this.headerView = new HeaderView({
        boardView: this,
        type: this.options.type
      });
      this.getRegion('headerRegion').show(this.headerView);

      //-------------------
      this.filtersView = new FiltersView({
        boardView: this,
        type: this.options.type,
        endUserId: this.options.endUserId
      });
      this.getRegion('filtersRegion').show(this.filtersView);

      //-------------------
      this.languageFilterView = new LanguageFilterView({
        boardView: this,
        filters: this.filtersView.model
      });

      // Apply initial language filter to model before kanban is created
      if (this.languageFilterView.hasLanguages()) {
        this.listenTo(this.languageFilterView, 'language:change', this.onLanguageFilterChange);
        
        // Show language filter in the filters banner quick access region
        this.filtersView.$el.find('.body').prepend('<div class="language-filter-region"></div>');
        this.filtersView.$el.find('.language-filter-region').append(this.languageFilterView.render().$el);
        this.languageFilterView.triggerMethod('show');

        // Set initial webshop filter on model (without triggering fetch yet)
        var initialWebshops = this.languageFilterView.getSelectedWebshops();
        if (initialWebshops.length > 0) {
          var webshopValue = initialWebshops.join(',');
          this.filtersView.model.set('webshop', webshopValue);
        }
      }

      //-------------------
      this.kanbanView = new KanbanView({
        boardView: this,
        parentStatus: this.options.parentStatus,
        type: this.options.type,
        filtersView: this.filtersView
      });
      this.getRegion('kanbanRegion').show(this.kanbanView);
    },

    onLanguageFilterChange: function (webshops) {
      var webshopValue = Array.isArray(webshops) ? webshops.join(',') : webshops;
      this.filtersView.model.set('webshop', webshopValue);
      this.filtersView.fetchWithoutStore(this.filtersView.model);
      this.filtersView.trigger('change', this.filtersView.model);
    }
  });
});
  
